// extracted by mini-css-extract-plugin
export default {"container":"CreateNormalCampaign_container__vgluf","wrapperCard":"CreateNormalCampaign_wrapperCard__ptpi8"};